import { State } from "reducers";

export const now = (state: State) => new Date(state.time.timeMs);
